import { render, staticRenderFns } from "./TheNew.vue?vue&type=template&id=374e5969&"
import script from "./TheNew.vue?vue&type=script&lang=js&"
export * from "./TheNew.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports